import React, { useEffect } from 'react';
import { Box, Text } from '@wix/design-system';
import { StyledText } from '../TextTyper/StyledText';
import s from './ErrorWidget.module.scss';
import { StatusAlert } from '@wix/wix-ui-icons-common';

export type ErrorWidgetProps = {
  message?: string;
};
export const ErrorWidget: React.FC<ErrorWidgetProps> = ({ message }) => {
  useEffect(() => {
    console.log('ErrorWidget', message);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className={s.container}>
      <StatusAlert className={s.icon} />
      <StyledText>
        <Text size="small" className={s.text}>
          Looks like this had trouble loading.
        </Text>
      </StyledText>
    </Box>
  );
};

export const ERROR_WIDGET = 'ERROR_WIDGET';
